import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { Button } from "@chakra-ui/react"
import "dayjs/locale/th"
import { useTranslation } from "react-i18next"
import { useForm } from "react-hook-form"
import { useHistory } from "react-router-dom"

import Layout from "../../components/layout/GeneralLayout"
import { WhitePanel, MenuCategoryForm, Alert } from "../../components"

import * as actions from "../../redux/actions"

export default function CreateMenuCategory() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const { control, handleSubmit, watch } = useForm()
  const [isError, setIsError] = useState(false)
  const [errMessage, setErrMessage] = useState("")

  const handleCreateMenuCategory = (data) => {
    dispatch(actions.createOneMenuCategory(data))
      .then(() => {
        history.goBack()
      })
      .catch((err) => {
        setIsError(true)
        setErrMessage(err?.message)
      })
  }
  return (
    <Layout categoryTitle={t("foodAndBeverage.title")} title="สร้างหมวดหมู่อาหาร">
      <Alert errMessage={errMessage} isError={isError} handleOnClose={() => setIsError(false)} />
      <div className="flex justify-between flex-wrap px-4">
        <Button colorScheme="purple" variant="outline" onClick={() => history.goBack()}>
          {t("general.back")}
        </Button>

        <div className="w-full md:w-1/4  self-center mt-2"></div>
      </div>
      <div className="p-4">
        <form onSubmit={handleSubmit(handleCreateMenuCategory)}>
          <WhitePanel>
            <MenuCategoryForm control={control} watch={watch} />
          </WhitePanel>
          <Button colorScheme="purple" variant="solid" type="submit" isFullWidth>
            {t("general.save")}
          </Button>
        </form>
      </div>
    </Layout>
  )
}
